import { Controller } from "@hotwired/stimulus";
import { initSwiper } from "../helpers/swiper-helper";

export default class extends Controller {
  connect() {
    // Avoid double-init across Turbo navigations
    this.element.swiper?.destroy?.(true, true);
    initSwiper(this.element);
  }

  disconnect() {
    this.element.swiper?.destroy?.(true, true);
  }
}
